export const languageCodesConstants = {
  english: "en",
  japanese: "ja",
  chinese: "cn",
  korean: "ko",
  spanish: "es",
  thai: "tha",
};

export const db_languages = {
  en: "en",
  ja: "jp",
  cn: "cn",
  ko: "ko",
  es: "sp",
  tha: "th",
};

export const chinaRegionLanguageConstants = [
  languageCodesConstants.chinese,
  languageCodesConstants.english,
];

export const japanRegionLanguageConstants = [
  languageCodesConstants.japanese,
  languageCodesConstants.english,
];

export const spainAndColumbiaRegionLanguageConstants = [
  languageCodesConstants.spanish,
  languageCodesConstants.english,
];

export const thaiRegionLanguageConstants = [
  languageCodesConstants.thai,
  languageCodesConstants.english,
];

export const koreanRegionLanguageConstants = [
  languageCodesConstants.korean,
  languageCodesConstants.english,
];

export const defaultRegionConstants = [languageCodesConstants.english];
